import { ProcessRole } from "./proceso-desempeno.model";

/**
 * El código del modo del líder (`review_modes[].code`, `review_type.code`). Es
 * también el `filters[review_type]` con el que se pide «Mi equipo»: sin él,
 * `team/processes/{id}/reviewees` trae además a los pares y al propio líder.
 */
export const LEADER_REVIEW_MODE = "managers";

/**
 * Las banderas de rol que trae un proceso: el `show` (`processes/:id/show`), cada
 * fila de `me/processes` y cada fila de `processes/latest`.
 */
export interface ProcessRoleFlags {
	is_reviewee?: boolean | null;
	is_reviewer?: boolean | null;
	/**
	 * true si el usuario tiene **al menos una asignación activa como líder**
	 * (`managers`) en el proceso, es decir, si tiene equipo. Quien solo evalúa a
	 * pares o a su líder llega con `is_reviewer: true` e `is_leader: false`.
	 */
	is_leader?: boolean | null;
}

/**
 * Si el usuario tiene equipo en el proceso (regla de Rodrigo): solo el líder
 * (`managers`) define y aprueba objetivos, hace seguimiento, calibra, da feedback,
 * arma el PDI de su gente y tiene «Mi equipo». Un par o un reporte directo que
 * evalúa a su líder no tiene equipo: solo evalúa competencias en la etapa de evaluación.
 *
 * Mientras el backend no mande `is_leader` se toma `is_reviewer`, que es como se
 * comportaba todo antes: nada se rompe antes de que llegue el campo.
 */
export function isProcessLeader(process: ProcessRoleFlags | null | undefined): boolean {
	if (!process) return false;
	return typeof process.is_leader === "boolean" ? process.is_leader : !!process.is_reviewer;
}

/**
 * Todos los roles: con ellos el Home y el listado filtran solo por el catálogo
 * cuando el proceso no informa ninguna bandera (ver el CLAUDE.md del módulo).
 */
export const ALL_PROCESS_ROLES: ProcessRole[] = ["reviewee", "reviewer", "leader"];

/**
 * El rótulo del rol del usuario en el proceso. «Líder» solo con equipo; quien
 * evalúa a otros sin tenerlo (pares, su líder) es «Evaluador».
 */
export function processRoleLabel(process: ProcessRoleFlags | null | undefined): string {
	const reviewee = !!process?.is_reviewee;
	if (isProcessLeader(process)) return reviewee ? "Evaluado y líder" : "Líder";
	if (process?.is_reviewer) return reviewee ? "Evaluado y evaluador" : "Evaluador";
	return reviewee ? "Evaluado" : "";
}
